import React from 'react';
import GlobeIcon from '../icons/GlobeIcon';
import LocationIcon from '../icons/LocationIcon';
import SurgeonIcon from '../icons/SurgeonIcon';

const Buttons = () => {
	const settings = window.findaWpHooks?.applyFilters('directory.settings', null);
	const isAffiliation = settings?.postType === 'finda_affiliation';

	return (
		<div className="fd-buttons">
			<a href={window.findaConnector.mapBaseUrl} className="fd-buttons__button">
				<GlobeIcon />
				View Map
			</a>
			{isAffiliation ? (
				<a href={window.findaConnector.locationBaseUrl} className="fd-buttons__button">
					<LocationIcon />
					View Healthcare Facilities
				</a>
			) : (
				<a href={window.findaConnector.affiliationBaseUrl} className="fd-buttons__button">
					<SurgeonIcon />
					View Doctors
				</a>
			)}
		</div>
	);
};

export default Buttons;
